import { EmblaEventType } from 'embla-carousel'
import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Carousel from './carousel'

class CarouselProgress extends BaseComponent {
  eventSetProgress: EmblaEventType

  constructor() {
    super()

    this.eventSetProgress =
      this.dataset.target === 'scroll' ? 'scroll' : 'settle'
  }

  connectedCallback(): void {
    this.updateProgressBar()

    if (this.carousel) {
      this.carousel.embla.on(this.eventSetProgress, this.handleProgress)
      this.carousel.embla.on('reInit', this.handleCarouselReInit)
    }
  }

  disconnectedCallback(): void {
    if (this.carousel) {
      this.carousel.embla.off(this.eventSetProgress, this.handleProgress)
      this.carousel.embla.off('reInit', this.handleCarouselReInit)
    }
  }

  handleProgress = (): void => {
    this.updateProgressBar()
  }

  handleCarouselReInit = (): void => {
    this.updateProgressBar()
  }

  updateProgressBar(): void {
    const progressBarIndicator = this.querySelector<HTMLElement>(
      '[data-carousel-progress-indicator]',
    )

    if (!progressBarIndicator) {
      return
    }

    const progress = this.getProgress()
    const isVerticalBar = this.dataset.axis === 'vertical'

    progressBarIndicator.style.transform = isVerticalBar
      ? `translate3d(0, ${progress}%, 0)`
      : `translate3d(${progress}%, 0, 0)`
  }

  getProgress(): number {
    const isTargetScroll = this.dataset.target === 'scroll'

    return isTargetScroll
      ? this.getProgressByScroll()
      : this.getProgressBySlideInView()
  }

  getProgressBySlideInView(): number {
    if (!this.carousel) {
      return 0
    }

    const slideCount = this.carousel.embla.slideNodes().length
    const visibleSlides = this.carousel.embla.slidesInView()
    const lastVisibleSlide = visibleSlides[visibleSlides.length - 1] + 1
    const progressPerSlide = 100 / slideCount
    const progress = Math.ceil(progressPerSlide * lastVisibleSlide)

    return progress
  }

  getProgressByScroll(): number {
    if (!this.carousel) {
      return 0
    }

    const scrollProgress = this.carousel.embla.scrollProgress()

    const progress = Math.max(0, Math.min(1, scrollProgress)) * 100

    return progress
  }

  get carousel(): Nullable<Carousel> {
    return this.closest<Carousel>('carousel-component')
  }
}

export default CarouselProgress
